import { Text, TextProps } from "@chakra-ui/react";
import React, { memo } from "react";
import omit from "lodash/omit";

interface Props extends TextProps {
  vr?: keyof typeof variantMap;
}

//
// const desktopToMobileSizeMap: Record<string, string> = {
//   "6xl": "4xl",
//   "5xl": "3xl",
//   "4xl": "2xl",
//   "3xl": "1xl",
//   "2xl": "xl",
//   "1xl": "lg",
//   xl: "md",
//   lg: "sm",
//   md: "sm",
//   sm: "sm",
// };

const variantMap = {
  body1: { color: "neutral.gray500", fontWeight: 400, fontSize: "1rem", lineHeight: "135%", as: undefined }, // ok
  body2: { color: "neutral.gray500", fontWeight: 400, fontSize: "0.875rem", lineHeight: "135%", as: undefined }, // ok
  body3: { color: "neutral.gray600", fontWeight: 400, fontSize: "0.75rem", lineHeight: "135%", as: undefined }, // ok
  title1: { color: "neutral.gray900", fontWeight: "bold", fontSize: "1rem", lineHeight: "135%", as: undefined }, // ok
  title2: { color: "neutral.gray900", fontWeight: "bold", fontSize: "0.875rem", lineHeight: "135%", as: undefined }, // ok
  title3: { color: "neutral.gray900", fontWeight: "bold", fontSize: "0.75rem", lineHeight: "135%", as: undefined },
  headline1: { color: "neutral.gray900", fontWeight: "bold", fontSize: "2rem", lineHeight: "135%", as: "h1" },
  headline2: { color: "neutral.gray900", fontWeight: "bold", fontSize: "1.75rem", lineHeight: "135%", as: "h2" }, // ok
  headline3: { color: "neutral.gray900", fontWeight: "bold", fontSize: "1.5rem", lineHeight: "135%", as: "h3" },
  headline4: { color: "neutral.gray900", fontWeight: "bold", fontSize: "1.25rem", lineHeight: "135%", as: "h4" },
  headline5: { color: "neutral.gray900", fontWeight: "bold", fontSize: "1.125rem", lineHeight: "135%", as: "h5" }, // ok
  display4: { color: "neutral.gray900", fontWeight: "bold", fontSize: "3rem", lineHeight: "135%", as: undefined },
  display5: { color: "neutral.gray900", fontWeight: "bold", fontSize: "2.5rem", lineHeight: "135%", as: undefined },
};

export const textVr = (vr: keyof typeof variantMap = "body1", overrideAs = true) => {
  if (!overrideAs) {
    return omit(variantMap[vr], "as");
  }
  return variantMap[vr];
};

export const UiText = memo(({ vr = "body2", ...rest }: Props) => {
  // const [isDesktop] = useMediaQuery(`(min-width: ${QUERY_MOBILE})`, {
  //   ssr: false,
  // });
  // let fontSizeObj: any;
  // let fontSizeInPx: any;
  // if (!isDesktop && isString(fontSize)) {
  //   fontSizeObj = {
  //     base: desktopToMobileSizeMap[fontSize] || fontSize,
  //     sm: "sm",
  //     md: "md",
  //     lg: "lg",
  //     xl: "xl",
  //   };
  // }
  // if (isDesktop) {
  //   // @ts-ignore
  //   const parentFontSize = fontSize?.base || fontSize;
  //   if (typeof parentFontSize === "string" && parentFontSize.includes("px")) {
  //     const currentSize = Number(parentFontSize.slice(0, -2));
  //     if (currentSize <= 10) {
  //       let adjustPx = 2;
  //       if (window.screen.width > 1500) {
  //         adjustPx = 3.5;
  //       }
  //       fontSizeInPx = `${currentSize + adjustPx}px`;
  //     }
  //   }
  // }
  const variantStyle = variantMap[vr];
  return (
    // @ts-ignore
    <Text
      // fontSize={fontSizeObj || fontSizeInPx || fontSize}
      {...variantStyle}
      {...rest}
    />
  );
});
